/**
 * Versandkosten-Rechner Logik
 * Aktualisiert Preise basierend auf dem Nutzerland.
 * * Voraussetzung: 
 * Im Liquid-Template muss vor dem Laden dieses Scripts 
 * die Variable window.shopUserCountry gesetzt sein.
 */

document.addEventListener("DOMContentLoaded", function() {
  updateShippingThresholds();
});

function updateShippingThresholds() {
  // 1. Das aktuelle Land aus der globalen Variable holen (definiert im Liquid)
  // Fallback auf 'DE', falls die Variable noch nicht existiert
  var userCountry = window.shopUserCountry || 'DE';

  // 2. Definition der Schwellenwerte
  //
  // QUELLE DER WAHRHEIT ist das Shopify-Versandprofil ("General profile",
  // 21 Zonen, 44 Methoden), NICHT die Seite /pages/versand. Nur das Profil
  // bestimmt, was der Kunde im Checkout tatsächlich zahlt.
  //
  // Am 2026-08-07 gegen das Profil abgeglichen. /pages/versand weicht bei elf
  // Ländern ab und ist veraltet — dort steht z. B. Frankreich 30 € statt 45 €,
  // Liechtenstein 39 € statt 199 €, Österreich 35 € als 39 €.
  //
  // Deutschland: GLS 2,99 € frei ab 30 €, DHL 3,49 € frei ab 35 €. Angezeigt
  // wird der günstigere Tarif.
  //
  // Bei JEDER Änderung beide Stellen anfassen: hier und
  // getShippingThresholdCents() in assets/custom.js (dort in Cent).
  var shippingRules = {
    'DE': { amount: 30, currency: '€' }, // Deutschland (GLS)
    'AT': { amount: 35, currency: '€' }, // Österreich
    'NL': { amount: 35, currency: '€' }, // Niederlande
    'BE': { amount: 35, currency: '€' }, // Belgien
    'LU': { amount: 35, currency: '€' }, // Luxemburg
    'HR': { amount: 35, currency: '€' }, // Kroatien
    'FR': { amount: 45, currency: '€' }, // Frankreich
    'IT': { amount: 45, currency: '€' }, // Italien
    'ES': { amount: 45, currency: '€' }, // Spanien
    'PT': { amount: 45, currency: '€' }, // Portugal
    'CH': { amount: 219, currency: '€' }, // Schweiz
    'LI': { amount: 219, currency: '€' }, // Liechtenstein
    'GB': { amount: 65, currency: 'GBP' }, // Vereinigtes Königreich
    'IE': { amount: 59, currency: '€' }, // Irland
    'SK': { amount: 35, currency: '€' }, // Slowakei
    'SI': { amount: 35, currency: '€' }, // Slowenien
    'NO': { amount: 2735, currency: 'NOK' }, // Norwegen
    'PL': { amount: 174.97, currency: 'PLN' }, // Polen
    'RO': { amount: 250, currency: 'RON' }, // Rumänien
    'CZ': { amount: 1230, currency: 'CZK' }, // Tschechien
    'DK': { amount: 290.63, currency: 'DKK' }, // Dänemark
    // Seit 2026-08-11 eigene Zonen statt der Sammelzone "Rest der Welt"
    'HU': { amount: 12800, currency: 'HUF' }, // Ungarn, ~35 € umgerechnet
    'LV': { amount: 45, currency: '€' }, // Lettland
    'LT': { amount: 45, currency: '€' }, // Litauen
    'BG': { amount: 45, currency: '€' }, // Bulgarien, seit 2026 Euroland
    'EE': { amount: 50, currency: '€' }, // Estland
    'GR': { amount: 50, currency: '€' }, // Griechenland
    'SE': { amount: 549, currency: 'SEK' }, // Schweden, ~50 € umgerechnet
    'FI': { amount: 65, currency: '€' }, // Finnland
    'MT': { amount: 99, currency: '€' }, // Malta
    'CY': { amount: 99, currency: '€' }, // Zypern
    'IS': { amount: 53400, currency: 'ISK' }, // Island, ~375 € umgerechnet
    'TR': { amount: 10800, currency: 'TRY' } // Türkei, ~195 € umgerechnet
  };

  // 3. Alle Elemente finden, die aktualisiert werden sollen
  // Wir suchen nach der ID (für deinen Banner) UND nach einer Klasse (für andere Stellen im Shop)
  var elements = document.querySelectorAll('#shipping-threshold, .js-shipping-threshold');
  
  // 4. Logik auf alle gefundenen Elemente anwenden
  elements.forEach(function(element) {
    if (userCountry && shippingRules[userCountry]) {
      var rule = shippingRules[userCountry];
      element.textContent = rule.amount + (rule.currency === '€' ? ' €' : ' ' + rule.currency);
    } else {
      // Fallback = Zone "Rest der Welt" im Versandprofil. Seit 2026-08-11 nur
      // noch 28 Länder, u. a. USA, Australien, Serbien und die Ukraine — die
      // zwölf europäischen sind in eigene Zonen umgezogen. 27,57 € Versand,
      // kostenlos ab 200 €.
      element.textContent = "200 €";
    }
  });

}